import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dateField: { type: String, default: "" },
    wageField: { type: String, default: "time_sheet_hourly_wage" },
    employeeField: { type: String, default: "" },
  }

  connect() {}

  // Triggered when employee selection changes
  setwage() {
    const raw = event.target.value
    const id = raw.split("||").pop()

    this.fetchAndSetWage(id)
  }

  // Triggered when date changes - looks up employee from the employee field
  updatewage() {
    if (!this.employeeFieldValue) return

    const employeeEl = document.getElementById(this.employeeFieldValue)
    if (!employeeEl || !employeeEl.value) return

    const raw = employeeEl.value
    const id = raw.split("||").pop()

    this.fetchAndSetWage(id)
  }

  fetchAndSetWage(employeeId) {
    if (!employeeId) return

    let url = `/employees/${employeeId}`
    if (this.dateFieldValue) {
      const dateEl = document.getElementById(this.dateFieldValue)
      if (dateEl && dateEl.value) {
        url += `?date=${encodeURIComponent(dateEl.value)}`
      }
    }

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((data) => {
        const wageEl = document.getElementById(this.wageFieldValue)
        if (wageEl) wageEl.value = data.hourly_wage
      })
      .catch((error) => {
        console.error("Failed to fetch employee wage:", error)
      })
  }
}
